import { AsyncCallResponse, Status, UserProductAccess } from '@zeotap-ui/core';
import { getUserProductAccess } from '../helper';
export const toUserProductAccessResponse = (
  res
): AsyncCallResponse<UserProductAccess> => ({
  status: Status.Success,
  data: getUserProductAccess(res?.permissions),
});
